// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.play-loading[data-v-f60b53d0] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 350px;\n  font-size: 16px;\n  color: #a8a8a8;\n  padding: 20px 0px;\n}\n.is-loading[data-v-f60b53d0] {\n  -webkit-animation: rotating 2s linear infinite;\n          animation: rotating 2s linear infinite;\n}\n.play-loading .el-icon[data-v-f60b53d0] {\n  margin-right: 5px;\n  font-size: 18px !important;\n}\n", ""]);
// Exports
module.exports = exports;
